import styles from './synthetic-data-banner.module.css';

import type { JSX } from 'react';
/**
 * Permanent non-dismissible banner whenever meta.dataSource === 'synthetic'
 * (plan §1.1 · high-risk Phase 4 gate).
 */

export interface SyntheticDataBannerProps {
  readonly dataSource: string;
}

export function SyntheticDataBanner({ dataSource }: SyntheticDataBannerProps): JSX.Element | null {
  if (dataSource !== 'synthetic') return null;
  return (
    <div
      className={styles['banner']}
      role="status"
      aria-live="polite"
      /* A live region's content is announced on change but is NOT its
         accessible name, so the banner was unaddressable by name once rendered
         — the exact query an E2E spec and an audit both reach for. */
      aria-label="Synthetic data"
      data-synthetic-banner=""
    >
      Synthetic data
    </div>
  );
}
